import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

export const textTheme = defineStyleConfig({
  variants: {
    subdued: defineStyle({
      color: "gray.500",
    }),
    disabled: defineStyle({
      color: "gray.400",
    }),
  },
});
